<template>
  <section>
    <header>
      <h1 class="page-header">Short deck pricing</h1>
    </header>
    <p>There are currently only two tools for short deck: the <router-link to="/short-deck/equity-calculator">Equity Calculator</router-link> and the <router-link to="/help/hit-calculator">Hit Calculator</router-link>.</p>
    <h3>Equity Calculator: Free</h3>
    <img src="/static/pages/short-deck-equity-calculator.png">
    <p>I'm experimenting with offering the <router-link to="/short-deck/equity-calculator">equity calculator</router-link> for free and making money with affiliate links for poker sites. I don't have the links yet, so stay tuned.</p>
    <h3>Hit Calculator: $150 for lifetime access after a 14 day free trial</h3>
    <img src="/static/pages/short-deck-hit-calculator.png">
    <p v-if="loggedIn">Head over to the <router-link to="/purchase-short-deck">purchase page</router-link> if you're interested.</p>
    <section v-else class="alert alert-info">
      Note: You need to <router-link to="/register">register</router-link> before you can pay. When you do register, you'll automatically be entered in to the 14 day free trial.
    </section>
  </section>
</template>

<script>
export default {
  name: 'short-deck-pricing',
  computed: {
    loggedIn: function () {
      return this.$store.getters['account/loggedIn'];
    },
  },
};
</script>

<style lang="scss" scoped>
  img {
    max-width: 100%;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/short-deck-pricing.vue